<div class="widget-subjects-wrapper">
  <card-header title="{{ 'SUBJECTS.CARD_TITLE' | translate }}">
    <div class="aside">
      <mat-form-field appearance="outline" class="search"
        *ngIf="isMainBelgradeCenter || isUserDrugostepeni || isGlobalAdmin">
        <mat-label>
          {{'GLOBAL.CENTER' | translate}}
        </mat-label>
        <input type="text" matInput [formControl]="subcenter" [matAutocomplete]="autoSubcenter" />
        <mat-autocomplete panelWidth="auto" #autoSubcenter="matAutocomplete" [displayWith]="displayCustomFormat"
          (optionSelected)="reloadSubjects($event.option.value)">
          <mat-option *ngFor="let cent of filteredSubcenters | async" [value]="cent">
            {{ cent.name }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
      <mat-form-field appearance="outline" class="search">
        <mat-label>{{ 'GLOBAL.SEARCH' | translate }}</mat-label>
        <input matInput type="text" [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          (matChipInputTokenEnd)="add($event)" placeholder="{{ 'GLOBAL.SEARCH' | translate }}">
      </mat-form-field>
      <button mat-icon-button class="button-square button-square--large button-export" color="primary"
        [matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger" [matBadge]="'*'" [matBadgeHidden]="!filterInUse"
        matTooltip="{{ 'SUBJECT_DOCUMENTS.TOOLTIP_FILTER' | translate }}" *ngIf="!isServiceProviderUser">
        <mat-icon class="button-square__icon">filter_list</mat-icon>
      </button>
      <mat-menu #menu="matMenu" class="filter-menu">
        <form [formGroup]="filterForm" class="filter-menu__content" (click)="$event.stopPropagation()">
          <field-holder> <mat-form-field appearance="outline">
              <mat-label> {{'GLOBAL.SUBJECT.STATUS' | translate}} </mat-label>
              <mat-select formControlName="status" [compareWith]="compareLoadedObjects">
                <mat-option *ngFor="let status of statusOptions" [value]="status.value">
                  {{ status.viewValue}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </field-holder>
          <field-holder>
            <mat-form-field appearance="outline">
              <mat-label>{{ 'GLOBAL.SEARCH_ADRESS' | translate }}</mat-label>
              <input matInput type="text" [matChipInputFor]="chipList" formControlName="address"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes" placeholder="{{'GLOBAL.SEARCH_ADRESS' | translate}}">
            </mat-form-field>
          </field-holder>
          <form-footer>
            <button class="form-footer__button form-footer__button--secondary" mat-stroked-button color="primary"
              type="button" (click)="resetFilter()">
              {{ 'SUBJECT_DOCUMENTS.FILTER.RESET' | translate }}
            </button>
            <button class="form-footer__button form-footer__button--primary" mat-flat-button color="primary"
              type="button" (click)="applyCustomFilter()">
              {{ 'SUBJECT_DOCUMENTS.FILTER.APPLY' | translate }}
            </button>
          </form-footer>
        </form>
      </mat-menu>
      <button mat-icon-button class="button-square button-square--large" color="primary"
        matTooltip="{{ 'SUBJECTS.NEW_SUBJECT' | translate }}" (click)="newSubjectInNewTab()"
        *ngIf="!isMainBelgradeCenter && !isUserDrugostepeni && !isGlobalAdmin && !isCpsuUser && !isServiceProviderUser">
        <mat-icon class="button-square__icon">person_add</mat-icon>
      </button>
    </div>
  </card-header>
  <mat-chip-list #chipList class="chip-list" [ngStyle]="{ 'display': searchItems.length > 0 ? 'block' : 'none' }">
    <mat-chip *ngFor="let item of searchItems" [selectable]="selectable" [removable]="removable"
      (removed)="remove(item)">
      {{item.name}}
      <mat-icon matChipRemove *ngIf="removable">
        cancel
      </mat-icon>
    </mat-chip>
  </mat-chip-list>
  <div *ngIf="!isCpsuUser&& !isCpsuCenter&& !isServiceProviderUser&& areLoaded">
    <table mat-table id="myTable" class="subjects__table" #myTable [dataSource]="page.content">
      <ng-container matColumnDef="registrationId">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'SUBJECTS.REGID' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.registrationId }}
        </td>
      </ng-container>
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef>{{ 'ID' | translate }}</th>
        <td mat-cell *matCellDef="let element; let i = index">
          {{ element.subjectIdentity.subjectId }}
        </td>
      </ng-container>
      <ng-container matColumnDef="lastName">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'SUBJECTS.LASTNAME' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">{{ element.lastName }}</td>
      </ng-container>
      <ng-container matColumnDef="firstName">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'SUBJECTS.FIRSTNAME' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">{{ element.firstName }}</td>
      </ng-container>
      <ng-container matColumnDef="dateOfBirth">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'SUBJECTS.DATEOFBIRTH' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element?.dateOfBirth | date:"dd.MM.yyyy." }}
        </td>
      </ng-container>
      <ng-container matColumnDef="jmbg">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'SUBJECTS.JMBG' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">{{ element.jmbg }}</td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns" class="subjects__row--header"></tr>
      <tr mat-row *matRowDef="let element; let row; columns: displayedColumns" class="subjects__row"
        (click)="clickSubject(element.subjectIdentity.subjectId)"></tr>
    </table>
  </div>
  <div *ngIf="(isCpsuUser || isCpsuCenter)&& areLoaded">
    <table mat-table id="myTable" class="subjects__table" #myTable [dataSource]="page.content">
      <ng-container matColumnDef="csrName">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'GLOBAL.CENTER' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element?.csrName }}
        </td>
      </ng-container>
      <ng-container matColumnDef="registrationId">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'SUBJECTS.REGID' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element?.registrationId }}
        </td>
      </ng-container>
      <ng-container matColumnDef="lastName">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'SUBJECTS.LASTNAME' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">{{ element?.lastName }}</td>
      </ng-container>
      <ng-container matColumnDef="firstName">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'SUBJECTS.FIRSTNAME' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">{{ element?.firstName }}</td>
      </ng-container>
      <ng-container matColumnDef="dateOfBirth">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'SUBJECTS.DATEOFBIRTH' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element?.dateOfBirth | date:"dd.MM.yyyy."}}
        </td>
      </ng-container>
      <ng-container matColumnDef="jmbg">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'SUBJECTS.JMBG' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">{{ element?.jmbg }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumnsCpsu" class="subjects__row--header"></tr>
      <tr mat-row *matRowDef="let element; let row; columns: displayedColumnsCpsu" class="subjects__row"
        (click)="clickSubject(element.id)"></tr>
    </table>
  </div>
  <div *ngIf="isServiceProviderUser && areLoaded">
    <table mat-table id="myTable" class="subjects__table" #myTable [dataSource]="page.content">
      <ng-container matColumnDef="fromCsrName">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'GLOBAL.CENTER' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element?.csrCsrName }}
        </td>
      </ng-container>
      <ng-container matColumnDef="registrationId">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'SUBJECTS.REGID' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element?.registrationId }}
        </td>
      </ng-container>
      <ng-container matColumnDef="lastName">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'SUBJECTS.LASTNAME' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">{{ element?.lastName }}</td>
      </ng-container>
      <ng-container matColumnDef="firstName">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'SUBJECTS.FIRSTNAME' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">{{ element?.firstName }}</td>
      </ng-container>
      <ng-container matColumnDef="dateOfBirth">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'SUBJECTS.DATEOFBIRTH' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element?.dateOfBirth | date:"dd.MM.yyyy."}}
        </td>
      </ng-container>
      <ng-container matColumnDef="jmbg">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'SUBJECTS.JMBG' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">{{ element?.jmbg }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumnsServiceProviders" class="subjects__row--header"></tr>
      <tr mat-row *matRowDef="let element; let row; columns: displayedColumnsServiceProviders" class="subjects__row"
        (click)="clickSubject(element.id)"></tr>
    </table>
  </div>


  <div class="paginator-wrapper">
    <app-custom-pagination [page]="page" (firstPageEvent)="getFirstPage()" (previousPageEvent)="getPreviousPage()"
      (nextPageEvent)="getNextPage()" (lastPageEvent)="getLastPage()" (pageSizeEvent)="getPageInNewSize($event)">
    </app-custom-pagination>
  </div>
</div>

<div class="spinner-wrapper" *ngIf="!areLoaded">
  <mat-progress-spinner color="primary" mode="indeterminate">
  </mat-progress-spinner>
</div>
